import { Link, usePage } from '@inertiajs/react'
import {
  CalendarDays,
  CheckSquare,
  LayoutGrid,
  Clock,
  LogOut,
  Home,
  Settings,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import * as Routes from '@/lib/routes'

// ナビゲーション項目
// タイムゾーンはサーバー側で管理されるため、today パラメータは不要
const navItems = [
  {
    href: Routes.root_path(),
    icon: Home,
    label: 'ダッシュボード',
  },
  {
    href: Routes.habits_path(),
    icon: CheckSquare,
    label: '今日の習慣',
  },
  {
    href: Routes.weekly_habits_path(),
    icon: LayoutGrid,
    label: '週間ビュー',
  },
  {
    href: Routes.monthly_habits_path(),
    icon: CalendarDays,
    label: '月間ビュー',
  },
  {
    href: Routes.timeline_habits_path(),
    icon: Clock,
    label: 'タイムライン',
  },
]

export function SideNav() {
  const { url } = usePage()
  const urlPath = url.split('?')[0]

  return (
    <aside className="border-border bg-card sticky top-0 hidden h-screen w-64 flex-col border-r sm:flex">
      {/* Logo */}
      <div className="border-border border-b p-6">
        <h1 className="text-primary text-xl font-bold">Init Habit</h1>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {navItems.map(({ href, icon: Icon, label }) => {
            const isActive = urlPath === href
            return (
              <li key={href}>
                <Link
                  href={href}
                  className={cn(
                    'flex items-center gap-3 rounded-lg px-4 py-3 transition-colors',
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                  )}
                >
                  <Icon className="h-5 w-5" />
                  <span>{label}</span>
                </Link>
              </li>
            )
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="border-border space-y-1 border-t p-4">
        <Link
          href={Routes.settings_path()}
          className={cn(
            'flex w-full items-center gap-3 rounded-lg px-4 py-3 transition-colors',
            urlPath === '/settings'
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:bg-muted hover:text-foreground'
          )}
        >
          <Settings className="h-5 w-5" />
          <span>設定</span>
        </Link>
        <Link
          href={Routes.destroy_user_session_path()}
          method="delete"
          as="button"
          className="text-muted-foreground hover:bg-muted hover:text-foreground flex w-full items-center gap-3 rounded-lg px-4 py-3 transition-colors"
        >
          <LogOut className="h-5 w-5" />
          <span>ログアウト</span>
        </Link>
      </div>
    </aside>
  )
}
